module.exports = __webpack_public_path__ + "static/media/wind_alert_small.807c32c5.png";